import { computed, inject, Injectable } from '@angular/core';
import { UserService } from '../services/user.service';
import { Permissions } from './permission.model';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  private userService = inject(UserService);

  private readonly permissionList = computed(
    () => this.userService.currentUser()?.permissions ?? [],
  );

  // navigation permissions
  readonly canGoBack = computed(() => !this.userService.isGuest());
  readonly canLogout = computed(() => !this.userService.isGuest());
  readonly canOpenLibrary = computed(
    () => this.userService.userLoaded() && !this.userService.isGuest(),
  );

  // action permissions
  readonly canUploadCase = computed(() => this.permissionList().includes(Permissions.UploadCase));
  readonly canEditCase = computed(() => this.permissionList().includes(Permissions.UploadCase));
  readonly canDeleteCase = computed(() => this.permissionList().includes(Permissions.DeleteCase));
  readonly canPublishCase = computed(() => this.permissionList().includes(Permissions.PublishCase));
  readonly canShareCase = computed(() => this.permissionList().includes(Permissions.ShareCase));
  readonly canExportInstantData = computed(() =>
    this.permissionList().includes(Permissions.ExportInstantData),
  );
  readonly canSeeAndGenerateCut = computed(() =>
    this.permissionList().includes(Permissions.VideoCutCase),
  );
  /**
   * Whether the user may drive a running live — stopping it, today.
   *
   * Guests are the line drawn here: a shared link is an invitation to watch, and someone handed a
   * live case must not be able to cut the recording for the room.
   *
   * The API guards the same action with `DELETE_ALL_EQUIPMENT_LIVE`, which this application's token
   * does not carry a name for yet. When it does, this is the one place to test it, and the button
   * needs no change.
   */
  readonly canControlLive = computed(() => !this.userService.isGuest());
}
